import { useTranslation } from 'react-i18next'
import type { CatalogStatus } from '../../../shared/types/models.js'

const BADGE_CLASS: Record<CatalogStatus, string> = {
  ACTIVE: 'status-badge status-badge--active',
  SUSPENDED: 'status-badge status-badge--suspended',
  ARCHIVED: 'status-badge status-badge--archived',
}

export default function ProductStatusBadge({ status }: { status: CatalogStatus }) {
  const { t } = useTranslation()
  const labels: Record<CatalogStatus, string> = {
    ACTIVE: t('products.statusActive'),
    SUSPENDED: t('products.statusSuspended'),
    ARCHIVED: t('products.statusArchived'),
  }
  return <span className={BADGE_CLASS[status]}>{labels[status]}</span>
}
